"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flash = void 0;
var jquery_1 = __importDefault(require("jquery"));
var Widget_1 = require("../tools/Widget");
var Flash = (function (_super) {
    __extends(Flash, _super);
    function Flash(node, config) {
        var _this = _super.call(this, node, config) || this;
        var bus = Flash.getBus();
        var handler = jquery_1.default.proxy(_this.flash, _this);
        bus.listen('interest.added', handler);
        bus.listen('favorite.added', handler);
        return _this;
    }
    Flash.prototype.flash = function () {
        var el = this.el;
        el.addClass("flash");
        setTimeout(function () {
            el.removeClass("flash");
        }, 1200);
    };
    return Flash;
}(Widget_1.Widget));
exports.Flash = Flash;
